var getNative=require("../internal/getNative"),nativeNow=getNative(Date,"now"),now=nativeNow||function(){return(new Date).getTime()};module.exports=now;